// extracted by mini-css-extract-plugin
export const review = "review-module--review--3IzGY";
export const star = "review-module--star--152gX";